import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'paginationFilter'
})
export class PaginationFilterPipe implements PipeTransform {

  transform(items: any[], value: number): any[] {
    if (!items) {
      return [];
    }

    if (value == null) {
      return items;
    }

    return [...items.slice(value).slice(0, 50)];
  }

}
